import React from 'react';
import Container from '../../../components/UI/Container';
import { enFr } from '../../../utils';
import ProblemSectionWrapper from './problemSection.style';

const ProblemSection = () => {
  const problems = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      ),
      text: enFr(
        'Outdated or underperforming web and mobile applications',
        'Des applications web et mobiles désuètes ou sous-performantes'
      ),
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
      text: enFr(
        'AI is clearly important, but no clear strategy for where to start',
        'L\u2019IA est clairement importante, mais aucune stratégie claire pour savoir par où commencer'
      ),
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      ),
      text: enFr(
        'Disconnected tools and siloed data across the organization',
        'Des outils déconnectés et des données cloisonnées à travers l\u2019organisation'
      ),
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      text: enFr(
        'Real risk of wasted budget on the wrong vendors or poor implementations',
        'Risque réel de gaspillage budgétaire avec les mauvais fournisseurs ou de mauvaises implémentations'
      ),
    },
  ];

  return (
    <ProblemSectionWrapper id="consulting">
      <Container>
        <div className="problem-content">
          <h2>
            {enFr(
              'Technology Should Work For You. Not Against You.',
              'La technologie devrait travailler pour vous. Pas contre vous.'
            )}
          </h2>
          <p className="lead">
            {enFr(
              'Whether it\u2019s a web application that needs to be built right, an AI opportunity that needs a clear strategy, or systems that need to talk to each other, most organizations struggle with the same core issue: finding a technical partner they can trust to actually deliver.',
              'Qu\u2019il s\u2019agisse d\u2019une application web à construire correctement, d\u2019une opportunité en IA nécessitant une stratégie claire, ou de systèmes qui doivent communiquer entre eux, la plupart des organisations font face au même enjeu fondamental : trouver un partenaire technique de confiance qui livre réellement.'
            )}
          </p>
          <div className="problems-grid">
            {problems.map((problem, index) => (
              <div className="problem-item" key={index}>
                <div className="problem-icon">{problem.icon}</div>
                <p>{problem.text}</p>
              </div>
            ))}
          </div>
          <div className="bridge-statement">
            <p>
              {enFr(
                'Awaken Solutions is the bridge between ambition and execution, building the software you need, integrating AI where it matters, and making your systems work together.',
                'Awaken Solutions est le pont entre l\u2019ambition et l\u2019exécution, développant les logiciels dont vous avez besoin, intégrant l\u2019IA là où ça compte et faisant fonctionner vos systèmes ensemble.'
              )}
            </p>
          </div>
        </div>
      </Container>
    </ProblemSectionWrapper>
  );
};

export default ProblemSection;
